var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('UsuarioSearch',{attrs:{"loading":_vm.fetching},on:{"search":function($event){_vm.params = $event}}})],1),_c('v-card-text',[_c('UserList',{attrs:{"params":_vm.params,"loading":_vm.fetching},on:{"update:loading":function($event){_vm.fetching=$event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }